import { useSelector } from "react-redux";

import { selectDetails, selectJourneyId } from "Services/state/journeys/JourneyStateSlice";

import { isNewJourney } from "../../helpers";

import styles from "./TitleBar.module.scss";

export function TagCount(): JSX.Element {
    const journeyId = useSelector(selectJourneyId);
    const { tags } = useSelector(selectDetails);
    const journeyTagCount = tags?.length || 0;

    if (isNewJourney(journeyId)) {
        return <></>;
    }

    return journeyTagCount > 0 ? (
        <span className={styles.journeyTagCount}>
            {journeyTagCount} {`Tag${journeyTagCount > 1 ? "s" : ""}`}
        </span>
    ) : (
        <span className={styles.tagCTA}>Add Tags</span>
    );
}
